import Tabs from "react-bootstrap/Tabs";
import Tab from "react-bootstrap/Tab";
import { useState } from "react";
import { useCircleDarkMode } from "../../hooks/useCircleDarkMode";
import { CC2MasterSheetDataRow } from "./types";

export const RenderDebugInfo = ({
  activePMID,
  simpleForm,
  pmRows,
  currentCC2,
  engineers,
  faultCodeOptions,
  returnReasonOptions,
  gradeOptions,
  packagingDescriptionOptions,
  disposalReasonOptions,
}: {
  activePMID?: string;
  simpleForm?: Record<string, any>;
  pmRows?: Record<string, any>;
  currentCC2?: CC2MasterSheetDataRow;
  engineers: Record<string, any>;
  faultCodeOptions?: Record<string, any>;
  returnReasonOptions?: Record<string, any>;
  gradeOptions?: Record<string, any>;
  packagingDescriptionOptions?: Record<string, any>;
  disposalReasonOptions?: Record<string, any>;
}) => {
  const [activeDebugTab, setActiveDebugTab] = useState("form");
  const darkMode = useCircleDarkMode();

  return (
    <Tabs
      activeKey={activeDebugTab}
      onSelect={(k) => k && setActiveDebugTab(k)}
      className="mb-3"
    >
      {/* Form Data Tab */}
      <Tab eventKey="form" title="Form Data">
        <div
          className="tab-content-wrapper p-2"
          style={{
            border: "1px solid #dee2e6",
            borderTop: "none",
            borderRadius: "0 0 5px 5px",
            backgroundColor: darkMode ? "#2b3035" : "#fff",
          }}
        >
          <h6>Simple Form</h6>
          <pre
            style={{
              background: darkMode ? "#343a40" : "#f8f9fa",
              padding: 10,
              maxHeight: "300px",
              overflow: "auto",
            }}
          >
            {JSON.stringify(simpleForm, null, 2)}
          </pre>

          <h6>PM Row Data</h6>
          {activePMID && pmRows ? (
            <pre
              style={{
                background: darkMode ? "#343a40" : "#f8f9fa",
                padding: 10,
                maxHeight: "300px",
                overflow: "auto",
              }}
            >
              {JSON.stringify(pmRows[activePMID], null, 2)}
            </pre>
          ) : (
            <p className="text-muted">No PMID selected</p>
          )}
        </div>
      </Tab>

      {/* CC2 Data Tab */}
      <Tab eventKey="cc2" title="CC2 Data">
        <div
          className="tab-content-wrapper p-2"
          style={{
            border: "1px solid #dee2e6",
            borderTop: "none",
            borderRadius: "0 0 5px 5px",
            backgroundColor: darkMode ? "#2b3035" : "#fff",
          }}
        >
          <pre
            style={{
              background: darkMode ? "#343a40" : "#f8f9fa",
              padding: 10,
              maxHeight: "400px",
              overflow: "auto",
            }}
          >
            {JSON.stringify(currentCC2, null, 2)}
          </pre>
        </div>
      </Tab>

      {/* Options & Lookups Tab */}
      <Tab eventKey="options" title="Options & Lookups">
        <div
          className="tab-content-wrapper p-2"
          style={{
            maxHeight: "500px",
            overflow: "auto",
            border: "1px solid #dee2e6",
            borderTop: "none",
            borderRadius: "0 0 5px 5px",
            backgroundColor: darkMode ? "#2b3035" : "#fff",
          }}
        >
          <h6>Engineers</h6>
          <pre
            style={{
              background: darkMode ? "#343a40" : "#f8f9fa",
              padding: 10,
            }}
          >
            {JSON.stringify(engineers, null, 2)}
          </pre>

          <h6>Fault Codes</h6>
          <pre
            style={{
              background: darkMode ? "#343a40" : "#f8f9fa",
              padding: 10,
            }}
          >
            {JSON.stringify(faultCodeOptions, null, 2)}
          </pre>

          <h6>Return Reasons</h6>
          <pre
            style={{
              background: darkMode ? "#343a40" : "#f8f9fa",
              padding: 10,
            }}
          >
            {JSON.stringify(returnReasonOptions, null, 2)}
          </pre>

          <h6>Grades</h6>
          <pre
            style={{
              background: darkMode ? "#343a40" : "#f8f9fa",
              padding: 10,
            }}
          >
            {JSON.stringify(gradeOptions, null, 2)}
          </pre>
        </div>
      </Tab>

      {/* Packaging & Disposal Tab */}
      <Tab eventKey="packaging" title="Packaging & Disposal">
        <div
          className="tab-content-wrapper p-2"
          style={{
            border: "1px solid #dee2e6",
            borderTop: "none",
            borderRadius: "0 0 5px 5px",
            backgroundColor: darkMode ? "#2b3035" : "#fff",
          }}
        >
          <h6>Packaging Descriptions</h6>
          <pre
            style={{
              background: darkMode ? "#343a40" : "#f8f9fa",
              padding: 10,
              maxHeight: "300px",
              overflow: "auto",
            }}
          >
            {JSON.stringify(packagingDescriptionOptions, null, 2)}
          </pre>

          <h6>Disposal Reasons</h6>
          <pre
            style={{
              background: darkMode ? "#343a40" : "#f8f9fa",
              padding: 10,
              maxHeight: "300px",
              overflow: "auto",
            }}
          >
            {JSON.stringify(disposalReasonOptions, null, 2)}
          </pre>
        </div>
      </Tab>
    </Tabs>
  );
};
